import apiClient from "services/axios";
import { parseParams } from "utils";

const API = {
  getData: "/api/v1/histories",
};

export const getHistoryData = async (filter) => {
  const response = await apiClient.get(API.getData, {
    params: filter,
    paramsSerializer: (params) => parseParams(params),
  });
  if (response) {
    return response.data;
  }
  return false;
};
